import React from 'react';
import './styles.css';
import './styles-heroes.hero.css';
import './styles-heroes.default.css';
import '../SharedUtils/c-buttons.css';
import '../FullWidthRichText/subtitle.css';
import '../FullWidthRichText/typography.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import { useSubtitleClasses } from '../FullWidthRichText/useSubtitleClasses';
import { addStyle, getTrackingAttributes } from '../SharedUtils/utils';
import {
  renderSubTitle,
  renderPrimaryHeading,
  renderSecondaryHeading,
  renderText,
  renderCtaLink,
} from '../FullWidthRichText/fieldsRenderer';
import { Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { addBackgroundColorVariables } from '../SharedUtils/themeColors';
import { useInvertedColor, useTheme } from '../SharedUtils/hooks';
import { getBackgroundColor } from '../SharedUtils/themeColors';

const TwoColumnTextImage = ({ fields, rendering, sitecoreContext }) => {
  const componentId = `c-${rendering.uid}`;

  const widgetStyles = {};
  const widgetClasses = ['o-widget', 'c-hero', 'c-hero--default', 'c-two-column-text-image'];

  const { isLight } = useTheme();
  const isInverted = useInvertedColor(fields);

  const backgroundColor = getBackgroundColor(fields, isLight);
  addBackgroundColorVariables(fields, widgetStyles);

  const hasBackground = !!backgroundColor;

  const isFullHeightImage = fields.ImageFullHeight?.value ? 'is-full-height-image' : '';

  const subTitleClasses = useSubtitleClasses('c-two-col-text-image__subtitle', fields);

  const heroColumnSecondaryClassList = [
    'c-hero__column--secondary',
    'column',
    'small-12',
    'u-text-center',
    isFullHeightImage,
  ];

  if (hasBackground) widgetClasses.push('has-padding');

  if (isInverted) widgetClasses.push('is-inverted');

  if (fields.ImageVerticalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageVerticalAlignment?.fields?.value?.value);

  const textAlignCss = fields.TextAlignRight?.value ? 'is-aligned-right' : '';

  if (textAlignCss) widgetClasses.push(textAlignCss);

  const disableMarginBottomCss = getDisableMarginBottomCss(fields);
  if (disableMarginBottomCss) widgetClasses.push(disableMarginBottomCss);

  addStyle(widgetStyles, '--two-column-text-image-padding-top', fields.PaddingTop?.value);
  addStyle(widgetStyles, '--two-column-text-image-padding-bottom', fields.PaddingBottom?.value);

  return (
    <div
      id={componentId}
      className={widgetClasses.join(' ')}
      style={widgetStyles}
      {...RenderingStyling(rendering.componentName)}
      tabIndex="-1"
    >
      <div className="background-color-theme background-wrapper">
        <div className={`c-container  container-row ${getColumnRatioClass(fields.ColumnsSize)}`}>
          <div className={heroColumnSecondaryClassList.join(' ')}>
            <figure tabIndex="0">
              <Image field={fields.Image} className="c-hero__image" width="" height="" />
            </figure>
          </div>
          <div className="c-hero__column--primary small-12">
            <div className="c-hero__content u-small-text-center">
              {renderSubTitle({
                field: fields.SubTitle,
                classes: subTitleClasses,
                sitecoreContext: sitecoreContext,
              })}
              {renderTextFields({ fields: fields })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(TwoColumnTextImage);

export const getDisableMarginBottomCss = (fields) => {
  return fields.DisableMarginBottom?.value ? 'u-pushing-0' : '';
};

export const getColumnRatioClass = (columnSize) => {
  switch (columnSize?.name) {
    case 'one third two third':
      return 'is-one-third-text';
    case 'two third one third':
      return 'is-two-third-text';
    default:
      return 'is-50-50';
  }
};

export const renderTextFields = ({ fields }) => {
  const trackingAttributes = getTrackingAttributes(fields);

  const heroDescriptionMarginCss = fields.CallToAction.value.href ? 'u-pushing-0' : '';

  const buttonClassList = ['c-button'];
  buttonClassList.push(fields.InvertButton?.value ? 'c-button--cta-invert' : 'c-button--cta');

  return (
    <>
      {renderPrimaryHeading({ fields: fields, classes: `c-hero__title`, headingType: 'H2' })}
      {renderSecondaryHeading({ field: fields.SecondaryHeading, classes: `c-hero__subtitle` })}
      {renderText({
        field: fields.Text,
        classes: `c-hero__description ${heroDescriptionMarginCss}`,
      })}

      {renderCtaLink({
        field: fields.CallToAction,
        classes: buttonClassList,
        tracking: trackingAttributes,
      })}
    </>
  );
};
